/// <reference path="../../_ext/editors/ItemGridEditor.ts" />

namespace TabAurous.ECommerce {

    import fld = ECommExchangeItemsRow.Fields;

    @Serenity.Decorators.registerClass()
    export class ECommExchangeItemsEditor extends _Ext.ItemGridEditor<ECommExchangeItemsRow> {
        

        protected getColumnsKey() { return "ECommerce.ECommExchangeItems"; }
        protected getDialogType() { return ECommExchangeItemsDialog; }
        protected getLocalTextPrefix() { return ECommExchangeItemsRow.localTextPrefix; }
        protected form: ECommExchangeItemsForm;

        private pendingChanges: Q.Dictionary<any> = {};

        // #region Variables
        public PartyId: number;
        public RateListId: number;
        public LaborListId: number;
        public StoneMarkup: number;
        public StoneDiscount: number;
        public LaborMarkup: number;
        public LaborDiscount: number;
        public ExchangeRate: number;
        public TransDate: Date;
        public DeptId: number;
        public image: string;
        NewLineNo: any;
        public VoucherTypeId: number;

        //For RM Setup
        public ProductTypeId: number;
        statement: string;
        private Master; 

        public isUpdate: number;
        public canUpdate: number;

        // #endregion


        constructor(container: JQuery) {
            super(container);
            this.slickContainer.on('change', '.edit:input', (e) => this.inputsChange(e));
            this.slickGrid.setOptions({ forceFitColumns: true });
        } 

        // #region Column Add -Remove
        protected getColumns() {

            var columns = super.getColumns();

            var num = ctx => ColumnFormatter.numericInputFormatter(ctx, this);
            var int = ctx => ColumnFormatter.integerInputFormatter(ctx, this); 

            var Department = Q.first(columns, x => x.field === fld.DepartmentId);
            Department.referencedFields = [fld.DepartmentId];
            Department.format = ctx => ColumnFormatter.selectFormatter(ctx, fld.DepartmentId, OMS.DepartmentMasterRow.getLookup(),this);
             
            Q.first(columns, x => x.field === fld.Pieces).format = int;
            Q.first(columns, x => x.field === fld.Weight).format = num;


            //To Add Delete Button on Item Row
            columns.unshift({
                field: 'Delete Row',
                name: '',
                format: ctx => '<a class="inline-action delete-row" title="delete">' +
                    '<i class="fa fa-trash-o text-red"></i></a>',
                width: 24,
                minWidth: 24,
                maxWidth: 24
            });

            return columns;
        }
         
        //#region  ItemGrid Inline Editor
        // **** Delete event handler ****
        protected onClick(e: JQueryEventObject, row: number, cell: number) {
            super.onClick(e, row, cell);


            if (e.isDefaultPrevented())
                return;

            var item = this.itemAt(row);
            //To Set Master Product Image
            this.image = item.ImageName;
            var target = $(e.target);

            // if user clicks "i" element, e.g. icon
            if (target.parent().hasClass('inline-action'))
                target = target.parent();

            if (target.hasClass('inline-action')) {
                e.preventDefault();

                if (target.hasClass('delete-row')) {
                    Q.confirm('This will effect Stock and can not be undone, Are you sure want to delete? ', () => {
                        if (item.TransItemId > 0) {

                            // **** Validate StockId from Stock Transactions ****
                            let StockID;
                            Stock.StockItemService.GetStockTransactions({
                                Line_No: item.Line_No,
                                TransId: item.TransId,
                                ProductId: item.ProductId,
                                Take: 1
                            },
                                response => StockID = response.Entities.length,
                                {
                                    async: false
                                });

                            Q.alert
                            if (StockID > 0 || StockID != null) {
                                Q.alert("This Item is used in other transactions, Can Not Delete!!");
                                return;
                            }
                            else { 
                                var id = this.id(item); 
                                this.view.deleteItem(id);
                            }
                        }
                        else {
                            var id = this.id(item); 
                            this.view.deleteItem(id);
                        }

                    });
                    this.view.refresh();
                }

                if (target.hasClass('edit numeric')) {
                    super.onClick(e, row, cell);
                }
            }

            if (target.hasClass('edit numeric')) {
                e.preventDefault();

                if (target.hasClass('edit numeric')) {
                    // var x = Q.coalesce(Q.trimToNull(input.val()), '0');
                    //TODO: Need to add System Parameter to enable disable blocking
                    var input = $(e.target);
                    if (input != undefined) {
                        if (this.canUpdate == 0) {
                            //Check Editable
                            target.addClass('readonly');
                            target.blur();
                            Q.alert("Readonly Detected")

                        }
                        else if (this.canUpdate == 1) {
                            target.removeClass('readonly');
                            var input = $(e.target);
                            var y = input.data();
                            if (y.field == "Weight" && item.ItemTypeId == 101) {
                                target.addClass('readonly');
                                target.blur();
                            }
                            else if (y.field == "Pieces" && item.ItemTypeId == 104) {
                                target.addClass('readonly');
                                target.blur();
                            }
                        } 
                    }

                    this.view.refresh();
                }
            }
        }


        //#region Inline Editor
        //Row Edit Event handler
        private inputsChange(e: JQueryEventObject, ) {
            var cell = this.slickGrid.getCellFromEvent(e);
            var item = this.itemAt(cell.row);
            var input = $(e.target);
            var field = input.data('field');
            var text = Q.coalesce(Q.trimToNull(input.val()), '0');
            var id = this.id(item);
            var pending = this.pendingChanges[id];

            // *** Format Number ***
            var effective = this.getEffectiveValue(item, field);
            var oldText: string = input.hasClass('numeric')
                ? Q.formatNumber(effective, '0.00')
                : effective as string;

            var value;

            // *** Validate Decimal & Integer***
            if (field === fld.Pieces || field === fld.Discount) {
                value = Q.parseDecimal(text);
                if (value == null || isNaN(value)) {
                    Q.notifyError(Q.text('Validation.Decimal'), '', null);
                    input.val(oldText);
                    input.focus();
                    return;
                }
            }
            else if (input.hasClass('numeric')) {
                var i = Q.parseInteger(text);
                if (isNaN(i) || i > 32767 || i < 0) {
                    Q.notifyError(Q.text('Validation.Integer'), '', null);
                    input.val(oldText);
                    input.focus();
                    return;
                }
                value = i;
            }
            else {
                value = text;
            }

            // *** Update Weight, Amount etc on Pieces Change***
            if (field === fld.Pieces && value > 0) {

                if (item.CalcOnId == 3) {
                    item.GrossAmount = item.UnitRate * value;
                    item.Weight = item.Pieces < value ? item.Weight * value : (item.Weight / item.Pieces) * value;
                    item.DiamondPieces = item.Pieces < value ? item.DiamondPieces * value : (item.DiamondPieces / item.Pieces) * value;
                    item.DiamondWeight = item.Pieces < value ? item.DiamondWeight * value : (item.DiamondWeight / item.Pieces) * value;
                    item.DiamondAmount = item.Pieces < value ? item.DiamondAmount * value : (item.DiamondAmount / item.Pieces) * value;
                    item.StonePieces = item.Pieces < value ? item.StonePieces * value : (item.StonePieces / item.Pieces) * value;
                    item.StoneWeight = item.Pieces < value ? item.StoneWeight * value : (item.StoneWeight / item.Pieces) * value;
                    item.StoneAmount = item.Pieces < value ? item.StoneAmount * value : (item.StoneAmount / item.Pieces) * value;
                    item.OtherPieces = item.Pieces < value ? item.OtherPieces * value : (item.OtherPieces / item.Pieces) * value;
                    item.OtherWeight = item.Pieces < value ? item.OtherWeight * value : (item.OtherWeight / item.Pieces) * value;
                    item.OtherAmount = item.Pieces < value ? item.OtherAmount * value : (item.OtherAmount / item.Pieces) * value;
                    item.NetWeight = item.Pieces < value ? item.NetWeight * value : (item.NetWeight / item.Pieces) * value;
                    if (item.WstPer != null) {
                        item.WstWt = item.NetWeight * (item.WstPer / 100);
                    }
                    item[field] = value;

                    this.view.updateItem(id, item);
                    this.view.refresh();
                }

            }
            // *** Calculate Wastage ***
            if (field === fld.WstPer && value >= 0) {
                item.WstWt = item.NetWeight * (value / 100);
                item[field] = value;
            }

            // *** Calculate Discount ***
            if (field === fld.Discount && value >= 0) {
                item.GrossAmount = item.NetAmount - value;
                item[field] = value;

            }

            // *** Set Department ***
            if (field === fld.DepartmentId && value > 0) {
                item[field] = value;

            }

            this.view.updateItem(id, item);
            this.view.refresh();

            if (input.hasClass('numeric'))
                value = Q.formatNumber(value, '0.00');

            if (input.hasClass('integer'))
                value = Q.formatNumber(value, '0');

            input.val(value).addClass('dirty');
        }


        private getEffectiveValue(item, field: any): any {
            var id = this.id(item);
            var pending = this.pendingChanges[id];
            if (pending && pending[field] !== undefined) {
                return pending[field];
            }
            return item[field];
        }

        protected onViewProcessData(response) {
            this.pendingChanges = {};
            return super.onViewProcessData(response);
        }

 
        setMasterValues() {
            this.TransDate = (this.parentDialog as ECommExchangeDialog).form.TransDate.valueAsDate;
            this.PartyId = (this.parentDialog as ECommExchangeDialog).form.PartyId.value;
            this.VoucherTypeId = (this.parentDialog as ECommExchangeDialog).form.VoucherTypeId.value;
        }

        // #endregion
        // #region Buttons Add-Remove
        protected getButtons() {
            let buttons = super.getButtons();
            //var grid = OMS.ProductSelectGrid;

            buttons.push({
                title: "Select Designs",
                cssClass: "stock-button",
                hotkey: "alt+k",
                hint: 'alt+k',
                onClick: () => {
                    var grid = Common.ProductSelectGrid;
                    this.setMasterValues();
                    // **** Validate Party before Item Selection ****
                    if (isNaN(this.PartyId)) {
                        Q.notifyWarning("Please select Supplier to proceed");
                        return;

                    }
                    else {
                        var filters: _Ext.SelectGridFilters = {
                        }
                        var pickerDialog = new _Ext.GridItemPickerDialog({
                            gridType: grid, multiple: true, title: "Select Items",
                            preSelectedKeys: this.value.map(k => k.ProductId), GridFilters: filters
                        });
                    }

                    pickerDialog.onSuccess = (selectedItems: any[]) => {
                        let selectedItems2 = selectedItems.filter(t => { return !Q.any(this.view.getItems(), n => n.ProductId == t.ProductId) });
                        var self = this;
                        var orddetails = [];
                        var rateListId = this.RateListId;
                        var laborListId = this.LaborListId;
                        var laborMarkup = this.LaborMarkup;
                        var newLineNo = this.NewLineNo;
                        var deptId = this.DeptId;
                        var companyId = Q.Authorization.userDefinition.CompanyId;

                        // #region Items to Grid
                        //for (let value of selectedItems2)
                        selectedItems2.forEach(function (value: OMS.ProductMasterRow) {
                            var PrdId = value.ProductId;
                            var AttributeId = value.AttributeId;
                            var bomdetails = [];
                            var labordetail = [];
                            // #region Product Attributes
                            // **** Load & assign Attributes of Product using AttributeId **** 
                            var Rate = 0;
                            var LaborRate = 0;
                            var Pieces = 0;
                            var Weight = value.Weight == undefined ? 1 : value.Weight;
                            var userDetails = Q.Authorization.userDefinition;

                            if (value.ItemTypeId == 101) {
                                Purchase.PurchaseMasterService.GetLineNo({}, response => newLineNo = response.Line_No, {
                                    async: false
                                });
                            }
                             
                            // **** Rate for RM ****
                            try {
                                switch (value.ItemTypeId) {
                                    case 104:
                                        // TODO: Add Currency, Date, Rate Type
                                        Rate = RateHelper.GetMetalRate(value.ProductTypeId, value.KaratId, false, self.TransDate);
                                        break;
                                    case 105:
                                        Rate = RateHelper.GetStonePurchaseRate(value.AttributeId, rateListId, value.ProductId, value.CostMethodId);
                                        break;
                                }
                            }
                            catch (undefined) {
                                Q.notifyWarning("Rate not defined for " + value.ProductCode);
                            }

                            var VoucherDetails = Q.first(OMS.VoucherMasterRow.getLookup().items, x => x.VoucherTypeId == self.VoucherTypeId);
                            switch (value.ItemTypeId) {
                                case 101:
                                    deptId = VoucherDetails.DefaultJewelleryDepartment;
                                    break;
                                case 104:
                                    deptId = VoucherDetails.DefaultMetalDepartment;
                                    break;
                                case 105:
                                    deptId = VoucherDetails.DefaultStoneDepartment;
                                    break;
                            }

                            // #endregion

                            // #region SKU, BOM and Rate BAsed on it

                            // **** Get SKU for Item ****
                            var purity = 0;
                            var pureweight = 0;
                            if (value.ItemTypeId == 101) {

                                var SKU = "0";

                                Pieces = 1;
                                Weight = value.Weight;
                                var laborcaloptions: RateHelper.LaborCalOptions = {
                                    ProductId: PrdId,
                                    AttributeId: value.AttributeId,
                                    RateListId: laborListId,
                                    Markup: laborMarkup,
                                    Pieces: value.Pieces,
                                    Weight: 0,
                                    NetWeight: 0,
                                    TransDate: self.TransDate,
                                    IsWastage: false,
                                    SettingId: 0,
                                    IsCustomerItem: false
                                }
                                var ItemLabor: ECommExchangeLaborRow[] = RateHelper.GetPurchseLabour(laborcaloptions)
                                if (ItemLabor.length > 0)
                                    for (var i = 0; i < ItemLabor.length; i++) {
                                        LaborRate += ItemLabor[i].LabourAmount;
                                        labordetail.push(ItemLabor[i]);
                                    }

                                if (!value.HasBom) {

                                    var d = Q.formatDate(self.TransDate, "dd/MM/yyyy");
                                    var MRate = OMS.MetalRateMasterRow.getLookup().items.filter(x => x.MetalTypeId == value.MetalId && x.RateTypeId == 33
                                        && x.CompanyId == userDetails.CompanyId && Q.formatDate(x.FromDate, "dd/MM/yyyy") == Q.formatDate(self.TransDate, "dd/MM/yyyy"));

                                    var m = Q.formatDate(MRate[0].FromDate, "dd/MM/yyyy");
                                    Rate = MRate[0].Rate;
                                }
                                if (!value.HasBom) {
                                    Q.reloadLookup(OMS.MetalRateMasterRow.lookupKey)
                                    var MRate = OMS.MetalRateMasterRow.getLookup().items.filter(x => x.MetalTypeId == value.MetalId && x.RateTypeId == 33
                                        && x.CompanyId == userDetails.CompanyId && Q.formatDate(x.FromDate, "dd/MM/yyyy") == Q.formatDate(self.TransDate, "dd/MM/yyyy"));
                                    Rate = MRate[0].Rate;
                                    var KaratId = Q.toId(value.KaratId);
                                    var puritydetails: OMS.AttributeMasterRow;
                                    OMS.AttributeMasterService.Retrieve({ EntityId: parseInt(KaratId) }, response => {
                                        puritydetails = response.Entity
                                    }, { async: false });
                                    var std = puritydetails.StdPurity;
                                    purity = std;
                                }


                                // #region ProductBOM


                                if (value.HasBom) {
                                    value.BOMDetails.forEach(function (bomvalue) {
                                        //Get Product Details  
                                        var BOMRate = 0;

                                        if (bomvalue.ItemType == "METAL") {
                                            var karat = bomvalue.KaratId;
                                            var MetalColor = bomvalue.MetalColorId;
                                            var StdPurity = bomvalue.Purity;
                                            var ItemTypeId = bomvalue.ItemTypeId;

                                            // *** Rate Calculation ***
                                            //Get Rate from Metal Rate Master Calculate BOM Amount and add it to Item Rate
                                            //TODO: Add From Date to Date
                                            BOMRate = OMS.MetalRateMasterRow.getLookup().items.filter(x => x.MetalTypeId == bomvalue.ProductTypeId && x.RateTypeId == 33
                                                && x.CompanyId == userDetails.CompanyId)[0].Rate;

                                            var Amount = bomvalue.CalcOnId == 3 ? bomvalue.Pieces * BOMRate : bomvalue.Weight * StdPurity * BOMRate;
                                            Rate += Amount;
                                            // *** End Rate Calculation ***

                                            var ExchangeBOM: ECommExchangeBOMRow = {
                                                ProductId: bomvalue.ProductId,
                                                ProductCode: bomvalue.ProductCode,
                                                BOMProductId: bomvalue.BOMProductId,
                                                BOMAttributeId: bomvalue.BOMAttributeId,
                                                BomRate: BOMRate,
                                                BomAmount: Amount,
                                                Remarks: bomvalue.Remarks,
                                                CalcOnId: bomvalue.CalcOnId,
                                                Pieces: bomvalue.Pieces,
                                                Weight: bomvalue.Weight,
                                                ItemTypeId: ItemTypeId,
                                                ItemType: bomvalue.ItemType,
                                                KaratId: karat,
                                                MetalColorId: MetalColor,
                                                //StdPurity: StdPurity,
                                                Attribute: bomvalue.Attribute,
                                                CertificateNo: bomvalue.CertificateNo
                                            }
                                            bomdetails.push(ExchangeBOM);
                                        }
                                        else if (bomvalue.ItemType == "STONE") {

                                            var Shape = bomvalue.ShapeId;
                                            var Size = bomvalue.StoneSizeId;
                                            var ItemTypeId = bomvalue.ItemTypeId;
                                            var Quality = bomvalue.QualityId;
                                            var StoneColor = bomvalue.StoneColorId;

                                            //Get Rate from Pricelist or Standard Rate to Calculate BOM Amount and add it to Item Rate

                                            BOMRate = RateHelper.GetStonePurchaseRate(bomvalue.BOMAttributeId, rateListId, bomvalue.BOMProductId, bomvalue.CostMethodId);
                                            var Amount = bomvalue.CalcOnId == 3 ? bomvalue.Pieces * BOMRate : bomvalue.Weight * BOMRate;
                                            Rate += Amount;
                                            var laborcaloptions: RateHelper.LaborCalOptions = {
                                                ProductId: bomvalue.BOMProductId,
                                                AttributeId: bomvalue.BOMAttributeId,
                                                RateListId: laborListId,
                                                Markup: laborMarkup,
                                                Pieces: bomvalue.Pieces,
                                                Weight: bomvalue.Weight,
                                                NetWeight: 0,
                                                TransDate: self.TransDate,
                                                IsWastage: false,
                                                SettingId: 0,
                                                IsCustomerItem: false
                                            }
                                            var ComponentLabor: ECommExchangeLaborRow[] = RateHelper.GetPurchseLabour(laborcaloptions)
                                            if (ComponentLabor.length > 0) {
                                                for (var i = 0; i < ComponentLabor.length; i++) {
                                                    LaborRate += ComponentLabor[i].LabourAmount;
                                                    labordetail.push(ComponentLabor[i]);
                                                }
                                            }

                                            var ExchangeBOM: ECommExchangeBOMRow = {
                                                ProductId: bomvalue.ProductId,
                                                ProductCode: bomvalue.ProductCode,
                                                BOMProductId: bomvalue.BOMProductId,
                                                BOMAttributeId: bomvalue.BOMAttributeId,
                                                BomRate: BOMRate,
                                                BomAmount: Amount,
                                                Remarks: bomvalue.Remarks,
                                                CalcOnId: bomvalue.CalcOnId,
                                                CalcOn: bomvalue.CalcOn,
                                                Pieces: bomvalue.Pieces,
                                                Weight: bomvalue.Weight,
                                                ItemType: bomvalue.ItemType,
                                                ItemTypeId: ItemTypeId,
                                                ShapeId: Shape,
                                                StoneColorId: StoneColor,
                                                QualityId: Quality,
                                                Attribute: bomvalue.Attribute,
                                                CertificateNo: bomvalue.CertificateNo
                                            }
                                            bomdetails.push(ExchangeBOM);
                                        }
                                    });
                                } else {
                                    purity = value.Purity;
                                    pureweight = Weight * purity;
                                }


                                // #endregion
                            }


                            var Exchange: ECommExchangeItemsRow = {
                                ProductId: value.ProductId,
                                AttributeId: value.AttributeId,
                                Attribute: value.Attribute,
                                Line_No: newLineNo,
                                PartyId: self.PartyId,
                                SKU: value.ItemTypeId == 101 ? SKU : "0",
                                DepartmentId: deptId,
                                ProductCode: value.ProductCode,
                                ProductName: value.ProductName,
                                ItemTypeId: value.ItemTypeId,
                                CategoryId: value.CategoryId,
                                ProductTypeId: value.ProductTypeId,
                                SubCategoryId: value.SubCategoryId,
                                BrandId: value.BrandId,
                                SuperTypeId: value.SuperTypeId,
                                CollectionId: value.CollectionId,
                                UnitRate: Rate,
                                UnitLabour: LaborRate,
                                Pieces: Pieces,
                                Weight: Weight,
                                OtherPieces: value.OtherPieces,
                                OtherWeight: value.OtherWeight,
                                StonePieces: value.StonePieces,
                                StoneWeight: value.StoneWeight,
                                NetWeight: value.NetWeight,
                                TaxCode: value.TaxCode,
                                NetAmount: value.HasBom ? (Rate + LaborRate) * 1 : (Rate * Weight) * purity,
                                GrossAmount: value.HasBom ? (Rate + LaborRate) * 1 : (Rate * Weight) * purity,
                                DiamondPieces: value.DiamondPieces,
                                DiamondWeight: value.DiamondWeight,
                                CalcOnId: value.CalcOnId,
                                BOMDetails: bomdetails,
                                CompanyId: companyId,
                                HSN: value.HSN,
                                KaratId: value.KaratId,
                                MetalColorId: value.MetalColorId,
                                QualityId: value.QualityId,
                                SieveId: value.SieveId,
                                ShapeId: value.ShapeId,
                                StoneColorId: value.StoneColorId,
                                StoneSizeId: value.StoneSizeId,
                                //StdPurity: PrdDetails.Purity,
                                ImageName: value.ImageName,
                                Purity: purity,
                                PureWeight: pureweight,
                                HasBom: value.HasBom,
                                StoneCutId: value.StoneCutId,
                                StonePolishId: value.StonePolishId,
                                StoneSymmetryId: value.StoneSymmetryId,
                                StoneFluorescenceId: value.StoneFluorescenceId,
                                StoneCuletId: value.StoneCuletId,
                                StoneGirdleId: value.StoneGirdleId,
                                StoneTable: value.StoneTable,
                                StoneDepth: value.StoneDepth,
                                StockAllocation:false
                            };

                            orddetails.push(Exchange);

                        });
                        for (let orderDetail of orddetails) {
                            orderDetail[this.getIdProperty()] = "`" + this.nextId++;
                            this.view.addItem(orderDetail);
                        }

                    }
                    pickerDialog.dialogOpen();
                }
            });
            return buttons;
        }
    }
}